module.exports = __webpack_public_path__ + "img/1.b747f91b.png";